import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

import SettingsConfirmation from '../SettingsConfirmation/SettingsConfirmation';

class FactoryDefaults extends Component {
  constructor(props) {
    super(props);

    const { routes } = this.props.content;

    this.state = {
      showConfirmation: false,
      buttonConfig: {
        left: {
          destination: routes.left
        },
        center: {
          onClick: this.reset
        },
        right: {
          destination: routes.right
        }
      }
    };
  }

  reset = () => this.setState({ showConfirmation: true });

  resetDismiss = () => this.setState({ showConfirmation: false });

  render() {
    const {
      showConfirmation,
      buttonConfig
    } = this.state;
    const { screens } = this.props.content;
    const [entryScreen, confirmationScreen] = screens;

    return showConfirmation ?
      <SettingsConfirmation
        content={confirmationScreen}
        onConfirm={this.resetDismiss}
        onCancel={this.resetDismiss}
      /> :
      [
        <Display key="display">
          <Header>
            <HeaderText value={entryScreen.title} />
          </Header>
          <Content>
            <Labels values={entryScreen.data} />
          </Content>
          <Footer>
            <DisplayButton src="icon-xm-left-arrow" />
            <DisplayButton src="icon-xm-enter" />
            <DisplayButton src="icon-xm-right-arrow" />
          </Footer>
        </Display>,
        <HardwareButtonWrapper key="buttons" config={buttonConfig} />
      ];
  }
}

FactoryDefaults.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

export default FactoryDefaults;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/FactoryDefaults/FactoryDefaults.js